// i18n area 'cluster' — locale es-ES (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/cluster.es-ES.meta.json.
import type { enUS } from './cluster'

export const esES: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Accesos de garantía',
      subtitle: 'La puerta de servicio del nodo: el acceso de solo lectura con contraseña temporal y la cuenta de emergencia con la contraseña de la caja fuerte',
      readOnlyTitle: 'Acceso de solo lectura (trantor)',
      stateNone: 'cerrado',
      stateGranted: 'abierto',
      stateGrantedPending: 'concedido — aplicándose en el nodo',
      grantedBy: 'Concedido por',
      grantedAt: 'Concedido el',
      expiresAt: 'Caduca el',
      reason: 'Motivo',
      endedAt: 'Cerrado',
      endedReason: {
        revoked: 'revocado',
        expired: 'caducado (TTL)',
        reboot: 'reinicio del nodo',
        failed: 'no aplicado (tarea fallida)'
      },
      grant: 'Conceder acceso de solo lectura…',
      grantTitle: 'Conceder acceso de solo lectura',
      grantSubmit: 'Conceder',
      grantError: 'La concesión ha sido rechazada',
      grantConfirm: 'TVirt genera una contraseña temporal para el usuario de sistema «trantor» (solo lectura: journal y diagnóstico, sin sudo) y la establece en el nodo con una tarea. La contraseña se muestra UNA sola vez, al confirmar; termina al caducar, al revocarla o en el próximo reinicio del nodo.',
      reasonLabel: 'Motivo',
      reasonHint: 'Por qué abres la puerta: queda en la concesión, en la auditoría y en el diario',
      ttlLabel: 'Duración',
      ttlHours: '{n} h',
      revoke: 'Revocar acceso de solo lectura…',
      revokeTitle: 'Revocar acceso de solo lectura',
      revokeSubmit: 'Revocar',
      revokeError: 'La revocación ha sido rechazada',
      revokeConfirm: 'La concesión termina ahora y una tarea vuelve a bloquear al usuario «trantor» en el nodo: la contraseña temporal deja de valer.',
      passwordTitle: 'Contraseña de solo lectura',
      passwordOnce: 'Esta contraseña se muestra UNA sola vez: cópiala ahora. No se guarda en ningún sitio y no podrá volver a leerse — si la pierdes, concede de nuevo.',
      passwordUser: 'Usuario',
      passwordLabel: 'Contraseña',
      passwordHint: 'Válida hasta el {until}, o hasta el próximo reinicio del nodo; utilizable cuando la tarea de concesión se haya completado. Acceso: ssh trantor@<dirección del nodo>.',
      emergencyTitle: 'Último acceso de emergencia (trantor-emergency)',
      lastLogin: '{time} vía {via} desde {from}',
      lastLoginNone: 'ninguno observado',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'consola',
        sudo: 'sudo',
        unknown: 'desconocido'
      },
      emergencyHint: 'La cuenta de emergencia «trantor-emergency» (sudo completo) está siempre habilitada con la contraseña generada en la instalación del nodo y guardada en la caja fuerte: TVirt no la conoce, no la rota y no la recupera. Cada inicio de sesión se registra aquí y en el diario de eventos.'
    },
    nodeFirewall: {
      tab: 'Firewall',
      title: 'Firewall de los nodos',
      subtitle: 'La postura del ruleset nftables que cada nodo se aplica a sí mismo — el único firewall de un nodo (firewalld está deshabilitado)',
      modeLabel: 'Postura',
      mode: {
        disabled: 'Deshabilitado — ningún ruleset en los nodos',
        permissive: 'Permisivo — cuenta y registra, no descarta nada',
        enforced: 'Impuesto — solo entra el registro derivado'
      },
      hint: {
        disabled: 'Como hoy: los nodos no llevan ningún ruleset. Pase a permisivo para LEER qué se descartaría antes de que se descarte.',
        permissive: 'Cada nodo aplica su propio ruleset derivado con policy accept: lo que el modo impuesto descartaría se cuenta y se registra (prefijo de journal «tvirt-node would-drop:»). Nada se bloquea.',
        enforced: 'Cada nodo aplica su propio ruleset derivado con policy drop: ssh y API desde cualquier sitio, store / live migration / overlay / Ceph solo desde los miembros, los listeners de los servicios de red desde la red servida. Cada cambio es un apply a confirmar — un nodo que no logra confirmar vuelve atrás por sí solo.'
      },
      confirmTitle: '¿Imponer el firewall de los nodos?',
      confirmBody: 'Cada nodo aplica el ruleset a confirmar: sondea backend, store y ssh a través de las nuevas reglas dentro del plazo y confirma — si no, vuelve por sí solo al ruleset anterior. Lea antes los contadores del modo permisivo en los nodos.',
      confirmSubmit: 'Imponer',
      confirmCancel: 'Cancelar',
      lensTitle: 'Firewall del nodo',
      loadError: 'No se pudo cargar la lente del firewall del nodo',
      noReport: 'Ningún informe de firewall de este nodo, todavía — el worker informa en la próxima pasada',
      firewalldActive: 'En este nodo corre firewalld: el firewall de nodo rechaza aplicarse a su lado (enmascare firewalld)',
      conditionUnconfirmed: 'Ningún ruleset confirmado, todavía — el nodo está abierto',
      conditionRolledBack: 'El último apply volvió atrás — la misma generación no se reintenta hasta que el registro cambie o la postura se cambie de nuevo',
      lastError: 'Último error',
      posture: 'Postura',
      observedAt: 'Observado',
      desiredGeneration: 'Generación deseada',
      componentTitle: 'Componente de nodo',
      componentSubtitle: 'tvirt-node-firewall — aplica al arrancar el ruleset confirmado, revierte por sí solo uno no confirmado',
      componentAbsent: 'El componente aún no ha informado',
      phase: 'Fase',
      phases: {
        none: 'Nunca aplicado',
        applied: 'Aplicado — a la espera de confirmación',
        confirmed: 'Confirmado',
        rolledBack: 'Revertido'
      },
      generation: 'Generación',
      appliedAt: 'Aplicado el',
      confirmedAt: 'Confirmado el',
      deadline: 'Plazo del rollback',
      lastRollback: 'Último rollback',
      registryTitle: 'Registro derivado',
      registrySubtitle: 'Los puertos que este nodo abre, por clase y origen — derivados del clúster, nunca editados a mano',
      registryEmpty: 'Nada derivado — postura deshabilitada sin ruleset confirmado, o ningún informe todavía',
      colClass: 'Clase',
      colPort: 'Puerto',
      colSource: 'Fuente',
      colOrigin: 'Origen',
      classes: {
        public: 'Pública',
        internode: 'Inter-nodo',
        tenant: 'Tenant'
      },
      sourceMembers: 'solo los miembros',
      sourceAnywhere: 'cualquier sitio',
      sourceBridge: 'en {iface}'
    },
    derivationDerived: 'derivado',
    derivationDiverged: 'divergente',
    derivationDerivedTip: 'El documento de red está DERIVADO de la fabric {fabric} y aún coincide con el render sobre las entradas actuales — clic para el plan de derivación.',
    derivationDivergedTip: 'La derivación de la fabric {fabric} cambió después del último apply (fabric, cableado, roles o referencias) — clic para el diff pendiente.',
    derivationRetiring: {
      one: '{n} dirección en drenaje',
      many: '{n} direcciones en drenaje',
      other: '{n} direcciones en drenaje'
    },
    standaloneHint: 'Este nodo no tiene clúster: aún no ha sido instalado. Los clústeres se crean O se unen (join) en la instalación — el token generado desde la tabla Servidores de un miembro se le da al instalador (dev: db:init-cluster / db:init-join).',
    reducedHint: 'Tus permisos cubren un scope, no el clúster completo: el inventario de la flota — nodos, ajustes y dispositivos — solo es visible para los administradores del clúster.',
    phaseReady: 'Listo',
    phaseForming: 'En formación',
    storeMembers: 'Miembros del store',
    watermark: 'Umbral de convergencia',
    configGeneration: 'Generación de config',
    converged: 'alineada',
    behind: 'atrasada — {m} / {n}',
    revision: 'Revisión',
    rolesTitle: 'Roles de red',
    rolesSubtitle: 'Direcciones por miembro de cada clase de tráfico — la conectividad vive en la red del host',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: 'hereda management',
    settingsTitle: 'Configuración',
    settingsSubtitle: 'Política de seguridad a nivel de clúster — evaluada por cada nodo desde su réplica local',
    taskRetentionTitle: 'Retención de tasks',
    taskRetentionSubtitle: 'GC unificado para todos los tasks — los tasks concluidos que superan la edad o el tope se recolectan, nunca los que están en curso',
    taskRetentionMaxAge: 'Edad máxima (días)',
    taskRetentionMaxCount: 'Número máximo de tasks',
    eventRetentionTitle: 'Retención de eventos',
    eventRetentionSubtitle: 'El GC del diario — una política independiente de la de las tareas: la tarea es una cola, el evento es memoria',
    eventRetentionMaxAge: 'Edad máxima (días)',
    eventRetentionMaxCount: 'Número máximo de eventos',
    spaceThresholdsTitle: 'Umbrales de espacio',
    spaceThresholdsSubtitle: 'Cuándo un almacenamiento que se llena entra en el diario (y en las notificaciones)',
    spaceLowPct: 'Aviso desde (% usado)',
    spaceCriticalPct: 'Crítico desde (% usado)',
    spaceOrderError: 'El crítico no puede estar por debajo del aviso',
    spaceThresholdsHint: 'Solo se configuran las entradas: la salida la deriva el motor, 5 puntos por debajo de cada umbral, para que un almacenamiento parado en la línea nunca se convierta en un metrónomo',
    failoverReserveTitle: 'Reserva de failover',
    failoverReserveSubtitle: 'Admission control N+1 — RAM mantenida libre para que el clúster pueda reiniciar su carga tras la pérdida de nodos',
    failoverReserveTolerate: 'Nodos cuya pérdida tolerar',
    failoverReserveOff: '0 — reserva apagada: ningún arranque se rechaza jamás por capacidad de failover',
    failoverReserveOn: 'Un arranque que erosionaría la reserva se rechaza con un 412 que explica los números',
    networkShapingTitle: 'Equidad de ancho de banda',
    networkShapingSubtitle: 'Los tres pesos por tipología del árbol de shaping por uplink — solo actúan bajo contención',
    networkShapingRest: 'Peso del resto (plano de control, storage, réplicas)',
    networkShapingOverlay: 'Peso de las redes overlay',
    networkShapingLiveMigration: 'Peso de la live migration',
    networkShapingHint: 'Cuota garantizada = peso / suma de los tres (por defecto 300 / 100 / 200, cada uno de 1 a 10000); con el enlace libre cada clase puede tomar todo el ancho de banda',
    debugModeTitle: 'Modo debug',
    debugModeSubtitle:
      'Errores detallados en los avisos genéricos de la GUI — para ver la causa real cuando una acción «fallida» en realidad tuvo éxito',
    debugModeLabel: 'Modo debug habilitado',
    debugModeOn: 'Los avisos de error genéricos añaden la causa subyacente — detalles internos visibles para cada operador',
    debugModeOffHint: 'Apagado — los avisos de error genéricos siguen siendo genéricos, sin detalles internos',
    nodeDetailsAction: 'Detalles del nodo',
    node: {
      docTitle: 'Nodo',
      notFound: 'Nodo no encontrado',
      tabOverview: 'Resumen',
      tabStats: 'Estadísticas',
      tabNetwork: 'Red',
      tabSettings: 'Configuración local',
      identityTitle: 'Identidad',
      heartbeatTitle: 'Heartbeat',
      ysqlPort: 'Puerto YSQL',
      revision: 'Revisión de config',
      versionsTitle: 'Versiones observadas',
      heartbeatSubtitle: 'El último estado que el nodo reportó sobre sí mismo',
      cpuTitle: 'CPU',
      cpuModelTitle: 'Modelo de CPU',
      memoryTitle: 'Memoria',
      hugePagesTitle: 'Páginas enormes',
      hugePagesPool: '{size}: {free} libres de {total}',
      hugePagesNone: 'Sin reserva',
      hugePagesNoneHint: 'El nodo no tiene páginas enormes reservadas: las VM que las piden no pueden arrancar aquí. La reserva se declara en el nodo, con los parámetros hugepagesz y hugepages del kernel o escribiendo nr_hugepages.',
      usageTitle: 'Uso actual',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'no observado — ninguna muestra fresca',
      statsNoData: 'Sin datos en el intervalo — las series del nodo las muestrea el propio nodo y se sirven en local.',
      observedTitle: 'Estado observado',
      observedSubtitle: 'Servicios y assets locales al nodo, tal como los ve el worker'
    },
    editRolesTitle: 'Editar los roles de red',
    memberNode: 'Nodo',
    memberIp: 'Dirección IP',
    addMember: 'Añadir miembro',
    lmInherit: 'Usar las direcciones de management',
    roleIpHint: 'Añadir y quitar miembros es libre; cambiar en el sitio la IP de un miembro existente se rechaza — el flujo de migración de IP llega en un round posterior.',
    roleError: 'No se pudieron actualizar los roles',
    nodesTitle: 'Nodos',
    addNodeTitle: 'Añadir nodo al clúster',
    addNode: 'Añadir nodo',
    addNodeError: 'No se pudo pre-registrar el nodo',
    nodeName: 'Nombre del nodo',
    nodeNameHint: 'debe coincidir con el nombre elegido en la instalación',
    nodeIp: 'IP de management',
    colName: 'Nombre',
    colPhase: 'Fase',
    colServices: 'Servicios',
    colWatermark: 'Watermark',
    colLastSeen: 'Último contacto',
    colUps: 'SAI',
    upsCordonChip: 'cordón SAI',
    upsCordonTip: 'El nodo se condenó por los hechos de su SAI ({time}): libera el cordón por sí solo cuando la red es estable y la batería está recargada',
    upsUnreachable: 'SAI inalcanzable',
    upsOnBattery: 'En batería',
    upsOnLine: 'En red',
    upsLowBattery: 'batería baja',
    upsNoEstimateChip: 'autonomía no estimada',
    upsNoEstimateTip: 'El SAI no publica la estimación de autonomía: el nodo se condena solo por el indicador LB (batería baja) del SAI — ajuste battery.runtime.low / LB en el propio SAI',
    upsLaneTip: 'Vía de apagado SAI desde {since}: condenado por {by}',
    upsUnit: 'unidad',
    upsStatus: 'estado NUT',
    upsLoad: 'carga',
    upsOnBatterySince: 'en batería desde',
    upsOnLineSince: 'en red desde',
    upsError: 'error',
    upsObservedAt: 'observado',
    upsNone: 'ninguna unidad SAI sirve a este nodo',
    upsBy: {
      runtime: 'autonomía bajo el umbral',
      lowBattery: 'indicador LB del SAI',
    },
    upsLane: {
      evacuate: 'evacuación',
      local: 'apagado en el sitio',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'apagando invitados',
      stoppingServices: 'apagando servicios',
      poweredOff: 'apagado',
    },
    upsTitle: 'SAI (NUT)',
    upsSubtitle: 'Unidades SAI y umbrales: nodo condenado con autonomía ≤ umbral o indicador LB (siempre respetado), reanudación con histéresis',
    upsRuntimeThreshold: 'Umbral de autonomía (s)',
    upsRuntimeThresholdHint: 'En batería, con autonomía estimada ≤ umbral el nodo se apaga en orden (predeterminado 300)',
    upsResumeStable: 'Red estable durante (s)',
    upsResumeStableHint: 'Reanudación solo con red continua desde al menos tantos segundos (predeterminado 60)',
    upsResumeCharge: 'Carga mínima al reanudar (%)',
    upsResumeChargeHint: 'Y batería recargada al menos a este porcentaje (predeterminado 25)',
    upsPolicyNote: 'El indicador LB (batería baja) del SAI condena siempre y no se desactiva; no existe un umbral sobre el tiempo en batería. Cada unidad puede sobrescribir los tres números.',
    upsUnitNew: 'nueva unidad',
    upsUnitSelectors: '{n} selector(es) por etiqueta (solo CLI)',
    upsUnitName: 'Nombre de la unidad',
    upsUnitMode: 'Modo',
    upsModeExternal: 'externa (upsd ajeno)',
    upsModeManaged: 'gestionada (SAI conectado a un nodo)',
    upsUnitUpsname: 'Nombre NUT (upsname)',
    upsUnitHost: 'Host upsd',
    upsUnitAttachedNode: 'Nodo conectado',
    upsUnitDriver: 'Controlador NUT',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Dispositivo del controlador',
    upsUnitDeviceHint: 'la línea port= de ups.conf: vacío = auto',
    upsUnitPort: 'Puerto upsd',
    upsUnitServedNodes: 'Nodos servidos',
    upsUnitServedNodesHint: 'nombres de nodos separados por comas (los selectores por etiqueta pasan por la CLI)',
    upsUnitOverrideHint: 'vacío = predeterminado del clúster',
    upsUnitAdd: 'Añadir unidad',
    unreachableSince: 'Inalcanzable — último heartbeat {time}',
    overlaysChip: 'overlays',
    overlaysBehind: 'El dataplane overlay aún no ha realizado la configuración overlay actual',
    overlaysError: 'Última pasada de reconciliación overlay fallida: {error}',
    storeChip: 'store',
    phase: {
      'pending-join': 'A la espera del join',
      'joining': 'En adhesión',
      'member': 'Miembro'
    },
    tokenTitle: 'Join token',
    tokenOnce: 'Se muestra solo ahora — cópielo de inmediato, no podrá leerse nunca más',
    copy: 'Copiar',
    copied: 'Copiado',
    close: 'Cerrar',
    revokeTitle: 'Revocar el pre-registro',
    revoke: 'Revocar',
    revokeError: 'No se pudo revocar el registro',
    promote: 'Promover a store member',
    demote: 'Quitar el rol store-member',
    troubleshoot: 'Resolución de problemas',
    promoteTitle: 'Promover a store member',
    demoteTitle: 'Quitar el rol store-member',
    promoteHint: 'El nodo entra en el quórum de los masters de YugabyteDB. La verdadera HA requiere tres store members.',
    demoteHint: 'El nodo sale del quórum de los masters y detiene sus servicios store.',
    storeError: 'El cambio del store-member fue rechazado',
    attest: 'Atestiguar apagado…',
    attestTitle: 'Atestiguar nodo apagado',
    attestSubmit: 'Atestiguar apagado',
    attestConfirm: 'Está declarando este nodo apagado, bajo su propio riesgo: atestiguar un nodo en realidad vivo arriesga VMs en doble ejecución. Sus tasks se marcan fallidos y las authorities de sus VMs pasan a ser transferibles.',
    attestError: 'La atestación fue rechazada',
    attestedChip: 'atestiguado apagado',
    maintenanceChip: 'mantenimiento',
    guestToolsChip: 'TVirt Guest Tools (asset ISO local al nodo)',
    maintenanceEnter: 'Activar mantenimiento',
    maintenanceExit: 'Desactivar mantenimiento',
    maintenanceEnterTitle: 'Activar mantenimiento',
    maintenanceExitTitle: 'Desactivar mantenimiento',
    maintenanceEnterSubmit: 'Activar mantenimiento',
    maintenanceExitSubmit: 'Desactivar mantenimiento',
    maintenanceEnterConfirm: 'El nodo se acordona y se vacía: los servicios de red y las instancias App cuya authority posee se transfieren (las instancias en frío: detenidas y segadas aquí, recreadas en el nodo de destino — parada), las VM encendidas se migran en vivo donde es posible y se apagan de forma ordenada si no, las tareas en curso terminan, el trabajo nuevo queda en espera y las VM apagadas pierden su authority — Proximity las recoloca en el siguiente arranque. Nada vuelve solo al terminar el mantenimiento.',
    maintenanceExitConfirm: 'El nodo vuelve a tomar trabajo y Proximity vuelve a considerarlo para la colocación. Las VMs vuelven solo cuando se arrancan.',
    maintenanceError: 'La solicitud de mantenimiento fue rechazada',
    maintenancePlanTitle: 'Plan de evacuación',
    maintenancePlanLoading: 'Calculando el plan de evacuación…',
    maintenancePlanError: 'No se pudo cargar el plan de evacuación — el drain migrará igualmente donde sea posible y detendrá el resto.',
    maintenancePlanEmpty: 'Nada que evacuar en este nodo — ningún servicio de red activo, ninguna instancia App deseada en ejecución, ninguna VM encendida.',
    maintenancePlanSummary: '{migrate} objetos migrarán (VM, servicios de red, instancias App), {stop} se detendrán o se quedarán donde están.',
    maintenancePlanReserve_ok: 'Reserva de failover tras el vaciado: intacta — quedan {headroom} GiB arrancables tolerando la pérdida de {n} nodo(s).',
    maintenancePlanReserve_eroded: 'Reserva de failover tras el vaciado: casi consumida — quedan solo {headroom} GiB de los {reserve} GiB mantenidos libres para {n} fallo(s) de nodo.',
    maintenancePlanReserve_exhausted: 'Reserva de failover tras el vaciado: AGOTADA — faltan {headroom} GiB de los {reserve} GiB necesarios para tolerar {n} fallo(s) de nodo. Mientras este nodo esté fuera, los nuevos arranques de VM serán rechazados.',
    maintenancePlanReserve_unknown: 'Reserva de failover tras el vaciado: no calculable — ningún nodo restante ha declarado su memoria.',
    maintenancePlanReserveHugePages: 'Páginas enormes de {size} tras el vaciado — libres: {free} de {capacity}, requeridas como reserva: {reserve}.',
    maintenancePlanActionMigrate: 'migra',
    maintenancePlanActionMigrateWarning: 'migra (regla soft violada)',
    maintenancePlanActionStop: 'se detiene',
    maintenancePlanActionBlocked: 'bloqueada',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'servicio de red',
    maintenancePlanKindApp: 'instancia App',
    maintenancePlanColdMove: 'Movimiento en frío: el pod se detiene y se siega aquí y su worker lo recrea en el nodo de destino — parada hasta el siguiente pass del worker de destino.',
    caFingerprint: 'Fingerprint de la CA del clúster',
    staleChip: 'desactualizado',
    troubleshootTitle: 'Resolución de problemas del store',
    restartStore: 'Reiniciar los servicios store',
    restartHint: 'Si el store hace de las suyas, reinicie sus servicios. Avanzado — usar con cautela.',
    restartQueued: 'Task de reinicio en cola',
    restartError: 'No se pudieron reiniciar los servicios',
    svcActive: 'activo',
    svcWanted: 'deseado, no activo',
    svcStopped: 'detenido',
    noServices: 'Ningún servicio reportado'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'El inventario de GPU de todo el clúster agrupado por modelo — las tarjetas observadas por nodo, con los registros marcados y sus tags',
    usbTitle: 'Recursos USB',
    usbSubtitle: 'El inventario USB de todo el clúster agrupado por modelo — los dispositivos observados por nodo, con los registros de ambos modelos (por dispositivo, por puerto) y sus tags',
    markedChip: '{n} usables por TVirt',
    orphanChipGpu: '{n} huérfanas',
    orphanChipUsb: '{n} huérfanos',
    colNode: 'Nodo',
    colRegistration: 'Registro',
      noRegsHint: 'Ningún registro — el dispositivo se marca "usable por TVirt" desde el diálogo del nodo (Nodos › nodo › Configuración).',
      colDevice: 'Dispositivo',
      colObserved: 'Observados',
      colRegs: 'Registros',
      regsNone: 'ninguno',
      colPci: 'Dirección PCIe',
      colIdentity: 'Identidad / puerto',
      colClasses: 'Clases (tags)',
      colActions: 'Acciones',
      manageOnNode: 'Gestionar en el nodo {node} (el marcado vive en el diálogo del nodo)',
      introTitle: 'El inventario de clúster de los dispositivos USB y PCIe usables por TVirt©.',
      introStep1: '1. Los nodos descubren solos sus GPU y sus dispositivos USB (censo en el heartbeat).',
      introStep2: '2. Un dispositivo se marca "usable por TVirt" desde el diálogo del NODO (Nodos › nodo › Configuración) — el marcado lo liga a vfio y lo registra aquí.',
      introStep3: '3. Aquí se dan a los registros sus CLASES vía tags (p. ej. gpu_class=compute): los requisitos de las VMs pedirán una clase, y el scheduler elegirá un nodo con un dispositivo libre compatible.',
    colMode: 'Modo',
    colState: 'Estado',
    colNotes: 'Notas',
    colTags: 'Tags',
    modeDevice: 'por dispositivo',
    modePort: 'por puerto',
    usable: 'usable',
    orphanGpu: 'huérfana',
    orphanUsb: 'huérfano',
    hubChip: 'hub',
    orphanPortsTitle: 'Registros por puerto sin dispositivo conectado — reconecte un dispositivo o desmárquelos desde el nodo',
    gpusEmpty: 'Ninguna GPU observada aún en ningún nodo',
    usbEmpty: 'Ningún dispositivo USB observado aún en ningún nodo'
  },
  settings: {
    passwordMinLength: 'Longitud mínima de la contraseña',
    sessionIdle: 'Timeout de inactividad de la sesión (minutos)',
    lockoutThreshold: 'Bloqueo tras intentos fallidos',
    lockoutDuration: 'Duración del bloqueo (minutos)',
    keyboardLayout: 'Layout del teclado',
    keyboardLayoutHint: 'p. ej. it, en-us — vacío para el default de QEMU',
    syslogEndpoint: 'Endpoint syslog',
    syslogEndpointHint: 'host:puerto — vacío para deshabilitar el reenvío',
    syslogTls: 'TLS',
    maxQueued: 'Máximo de tasks en cola',
    concurrency: 'Concurrencia del worker',
    concurrencyHint: 'Aplicada al vuelo por el worker',
    notesTitle: 'Notas',
    save: 'Guardar',
    saved: 'Configuración guardada',
    saveError: 'No se pudo guardar la configuración'
  },
  localSettings: {
    derivedChip: 'derivado',
    derivedTip: 'Este device es PROPIEDAD de la derivación de la fabric (H2): el editor rechaza tocarlo — modifica la fabric (o el cableado) y reaplica, o recupéralo aquí abajo.',
    takeOwnership: 'Tomar posesión',
    takeOwnershipTitle: 'Tomar posesión (take-ownership)',
    takeOwnershipConfirm: '{name} sale del bloque fabric y vuelve a ser un device MANUAL gobernado por este editor. El nodo pasa a divergente, y el próximo apply de la derivación lo rechazará (manualConflict) hasta que lo renombres o lo quites — o corrijas la fabric.',
    nodeSettingsTitle: 'Configuración del nodo',
    nodeSettingsSubtitle: 'Lo que este nodo aplica — cola de tasks, consola, reenvío de logs — más sus tags y las notas',
    baseTitle: 'Reservas del host (TVirt Proximity)',
    baseSubtitle: 'CPU y RAM reservadas al sistema operativo del host — los inputs de la capacidad empírica con la que Proximity coloca las VMs',
    baseMemory: 'RAM base (MiB)',
    baseMemoryHint: 'Total observado: {total} MiB. Usable para las VMs = total − base − RAM de las VMs encendidas colocadas aquí.',
    baseMemoryHintNoTotal: 'Usable para las VMs = total observado − base − RAM de las VMs encendidas colocadas aquí.',
    baseCpu: 'Cores de CPU base',
    baseCpuHint: 'CPU lógicas observadas: {total}. Usadas solo como peso de ranking — el overcommit de vCPU es normal.',
    baseCpuHintNoTotal: 'Usadas solo como peso de ranking — el overcommit de vCPU es normal.',
    baseHint: 'La RAM es la puerta rígida de admisión: una VM que no cabe en la RAM usable se rechaza con un error que habla claro. Suba la base en los hosts que alojan miembros del store o demonios Ceph.',
    placementTitle: 'Ubicación física',
    placementSubtitle: 'Dónde está físicamente este servidor — declarado una vez, sirva a lo que sirva',
    placementHint: 'La ubicación guía la jerarquía CRUSH de cada clúster Ceph con un OSD en este servidor: guardar un cambio realinea sus mapas vía task (host → rack → … → root). Las declaraciones parciales son legales — los niveles vacíos simplemente colapsan. Los nombres se comparten en todo el mapa: dos servidores en el mismo rack declaran el mismo nombre de rack.',
    placementNameInvalid: 'Nombre DNS-safe (minúsculas, dígitos, guiones)',
    placementEmpty: 'Vacío = no declarado',
    placementLevel: {
      chassis: 'Chasis',
      rack: 'Rack',
      row: 'Fila',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Sala',
      datacenter: 'Datacenter',
      zone: 'Zona',
      region: 'Región'
    },
    cablingTitle: 'Cableado',
    cablingSubtitle: 'A qué puerto del switch está conectada cada interfaz — la declaración vive en el nodo (Annex O.9)',
    cablingHint: 'Un cable por NIC, un cable por puerto en toda la flota (la API rechaza nombrando al titular). Cablear hacia un puerto miembro de un LAGG es legal — es el caso bond: la derivación futura lo renderizará como LACP.',
    cablingInterface: 'Interfaz',
    cablingNotCabled: '— no cableada —',
    cablingNoInterfaces: 'Ninguna interfaz de red observada',
    disksTitle: 'Discos',
    disksSubtitle: 'Dispositivos de bloques observados — un barrido por pasada de reconciliación; marque aquí los discos usables como OSD Ceph (N.15: la elegibilidad es explícita)',
    colDataDisk: 'Disco de datos',
    dataDisksHint: 'Marcar un dispositivo lo declara usable como OSD; el serial es su pin de identidad — copiado del hardware cuando el disco lo reporta, acuñado (tvirt-…) en caso contrario. El diálogo de registro Ceph ofrece solo los discos declarados.',
    diskDeclaredSerial: 'declarado',
    diskNotObserved: 'declarado pero no observado — reenganche el dispositivo o quite la marca',
    noDisks: 'Ningún dispositivo de bloques observado aún',
    colSerial: 'Serial',
    colModel: 'Modelo',
    colSize: 'Tamaño (GiB)',
    colDiskType: 'Tipo',
    colInUse: 'En uso',
    colObservedAt: 'Observado',
    diskInUse: 'en uso',
    diskFree: 'libre',
    diskMounted: 'montado',
    diskPartitions: 'particiones',
    passthroughTitle: 'Dispositivos passthrough',
    passthroughSubtitle: 'GPU y dispositivos USB observados — marque aquí lo que TVirt puede pasar a las VMs; el marcado registra la identidad del dispositivo (round U1+G1)',
    passthroughHint: 'El marcado registra el dispositivo (un id estable — el target de tags y requisitos de clase). Una GPU marcada tiene TODO su grupo IOMMU ligado a vfio-pci en bloque — deja el host de inmediato; desmarcar reengancha el driver nativo. Para USB existen ambos modelos ratificados: por dispositivo (vendor+producto, esté conectado donde esté) y por puerto físico (a la VM le llega lo que haya enchufado ahí). El USB no hace bind al marcarse — el attach ocurre en runtime de la VM.',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'Usable por TVirt',
    colGpu: 'GPU',
    colPciAddress: 'Dirección PCI',
    colDriver: 'Driver',
    colVerdict: 'Veredicto',
    gpuEligible: 'Elegible',
    gpuIneligible: 'No elegible',
    gpuReason: {
      'no-iommu': 'IOMMU no activo en el host',
      'group-spans-slots': 'grupo IOMMU no aislado: se extiende a otros slots',
      'multiple-display': 'grupo IOMMU no aislado: más de una función de vídeo',
      'foreign-function': 'grupo IOMMU no aislado: contiene una función ajena'
    },
    vfioNotReady: 'El IOMMU no está activo en este host: ninguna GPU es elegible hasta que la plataforma host lo habilite (ISO OEM) — TVirt nunca retoca los kernel args en runtime.',
    vfioMissingKernelArg: 'El IOMMU no está activo en este host: el firmware reporta VT-d/AMD-Vi (tabla ACPI DMAR/IVRS presente) pero falta el kernel arg — añada intel_iommu=on (Intel) o quite amd_iommu=off (AMD) de la command line del kernel y reinicie. TVirt nunca retoca los kernel args en runtime.',
    vfioFirmwareDisabled: 'El IOMMU no está activo en este host: VT-d/AMD-Vi está deshabilitado en el firmware (ninguna tabla ACPI DMAR/IVRS) o la CPU no lo soporta — habilítelo en el setup del firmware, ningún kernel arg puede encenderlo. TVirt nunca retoca el host en runtime.',
    gpuBindError: 'Bind vfio-pci fallido en {address}: {error}',
    firewallBridgesTitle: 'Firewall en bridges no gestionados',
    firewallBridgesSubtitle: 'Los bridges construidos a mano en este nodo cuyo setup consiente las chains de firewall renderizadas por TVirt en las NIC de invitado conectadas',
    firewallBridgesHint: 'TVirt no toca nunca el bridge ajeno — la chain ancla en el tap/veth, que es siempre de TVirt. La lista es una puerta de consentimiento: default-deny y anti-spoof pueden romper lo que un setup manual espera, así que una NIC con firewall en un bridge no gestionado NO listado aquí se rechaza con un error que habla claro.',
    firewallBridgesEmpty: 'Ningún bridge no gestionado consiente las chains de firewall renderizadas por TVirt en este nodo.',
    firewallBridgeAdd: 'Añadir bridge',
    firewallBridgeInvalid: 'No es un nombre de interfaz Linux (1-15 caracteres, sin slash ni espacios)',
    firewallBridgeDuplicate: 'Nombre ya en la lista',
    colMarkDevice: 'Por dispositivo',
    colMarkPort: 'Por puerto',
    usbHub: 'hub',
    colUsbId: 'Vendor:Product',
    colPort: 'Puerto',
    passthroughOrphan: 'huérfano — registrado pero ya no detectado: reconéctelo o desmárquelo',
    noGpus: 'Ninguna GPU observada aún',
    noUsb: 'Ningún dispositivo USB observado aún',
    networkGeneration: 'Generación de red',
    applied: 'Aplicada',
    converged: 'alineada',
    behind: 'atrasada — {m} / {n}',
    notConfigured: 'no configurada',
    rollbackBody: 'Aplicación de la generación {gen} fallida: {error}',
    rolledBackChip: 'rollback ejecutado',
    nicsTitle: 'NIC',
    nicsSubtitle: 'El registro de las NIC gestionadas — registrar ES declarar la gestión: una NIC registrada sin configuración se deja intacta (clear-if la declara explícitamente limpia), un dispositivo no registrado no se toca jamás',
    addNic: 'Registrar NIC',
    addNicTitle: 'Registrar NIC (add-nic)',
    delNic: 'Terminar gestión',
    delNicTitle: 'Terminar gestión (del-nic)',
    delNicConfirm: 'La gestión de {name} termina: la entrada del registro y su configuración se eliminan y el perfil TVirt se quita — el dispositivo queda tal como lo tiene Linux.',
    nicName: 'Nombre del dispositivo',
    nicMac: 'Dirección MAC permanente',
    nicMacHint: 'la MAC hardware permanente — la identidad estable fijada por el TVirt Server Installer',
    colObserved: 'Observada',
    nicObserved: 'observada',
    nicNotObserved: 'no observada',
    nicMacMismatch: 'MAC divergente — observada {mac}',
    noNics: 'Ninguna NIC registrada — registre un dispositivo para empezar a gestionarlo',
    noManagedDevices: 'Ningún dispositivo gestionado — registre primero una NIC, todo se construye sobre el registro',
    inventoryTitle: 'Dispositivos observados',
    inventorySubtitle: 'Actualizados en cada pasada de reconciliación por el worker del nodo — la validación verifica los nombres de los dispositivos contra este inventario',
    colDevice: 'Dispositivo',
    colType: 'Tipo',
    colMac: 'MAC',
    colLink: 'Link',
    colSpeed: 'Velocidad',
    colTopology: 'Topología',
    colMtu: 'MTU',
    colAddresses: 'Direcciones',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'LACP no agrega',
    noInventory: 'Ningún dispositivo reportado por ahora',
    interfacesTitle: 'Interfaces',
    interfacesSubtitle: 'Configuración L3 de las NIC registradas y de los dispositivos lógicos declarados — set-if sustituye el bloque entero, edit-if retoca las propiedades, clear-if lo vacía (limpieza explícita)',
    colConfig: 'Configuración deseada',
    clean: 'limpia',
    setIf: 'Editar direccionamiento',
    setIfTitle: 'Editar direccionamiento (set-if)',
    editIf: 'Editar propiedades',
    editIfTitle: 'Editar propiedades (edit-if)',
    clearIf: 'Vaciar configuración',
    clearIfTitle: 'Vaciar configuración (clear-if)',
    clearIfConfirm: 'La configuración de la interfaz se vacía. Una interfaz limpia es el prerrequisito para esclavizarla como miembro de bond/bridge o parent de VLAN.',
    ip4Mode: 'Modo IPv4',
    ip6Mode: 'Modo IPv6',
    modeUnconfigured: 'Sin configurar',
    modeStatic: 'Estática',
    modeDhcp: 'DHCP',
    ip4Addresses: 'Direcciones IPv4',
    ip6Addresses: 'Direcciones IPv6',
    addressesHint: 'CIDR, separadas por comas',
    gw4: 'Gateway IPv4',
    gw6: 'Gateway IPv6',
    dns: 'Servidores DNS',
    dnsHint: 'separados por comas — vacío borra el DNS (set-if sustituye el bloque)',
    routes4: 'Rutas estáticas IPv4',
    routes6: 'Rutas estáticas IPv6',
    routeTo: 'Destino (CIDR)',
    routeVia: 'Vía',
    addRoute: 'Añadir ruta',
    routesChip: 'rutas',
    mtu: 'MTU',
    mtuHint: 'vacío = default del driver',
    vlansTitle: 'VLAN',
    addVlan: 'Añadir VLAN',
    addVlanTitle: 'Añadir VLAN (add-vlan)',
    delVlanTitle: 'Eliminar VLAN (del-vlan)',
    vlanParent: 'Interfaz parent',
    vlanId: 'ID de VLAN',
    vlanPreview: 'Nombre del dispositivo',
    colParent: 'Parent',
    colVlanId: 'ID',
    noVlans: 'Ninguna VLAN declarada',
    bondsTitle: 'Bonds',
    addBond: 'Añadir bond',
    addBondTitle: 'Añadir bond (add-bond)',
    editBondTitle: 'Editar bond',
    editBond: 'Guardar bond',
    delBondTitle: 'Eliminar bond (del-bond)',
    bondName: 'Nombre del bond',
    members: 'Miembros',
    membersHint: 'los miembros deben ser interfaces limpias (sin configuración L3)',
    bondMode: 'Modo',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Miembro primario',
    rate: 'Rate LACP',
    hash: 'Política de hash en transmisión',
    colMembers: 'Miembros',
    colMode: 'Modo',
    noBonds: 'Ningún bond declarado',
    bridgesTitle: 'Bridges',
    addBridge: 'Añadir bridge',
    addBridgeTitle: 'Añadir bridge (add-bridge)',
    editBridgeTitle: 'Editar bridge',
    editBridge: 'Guardar bridge',
    delBridgeTitle: 'Eliminar bridge (del-bridge)',
    bridgeName: 'Nombre del bridge',
    stp: 'STP',
    stpOn: 'STP activo',
    stpOff: 'STP apagado',
    colStp: 'STP',
    noBridges: 'Ningún bridge declarado',
    hostnameTitle: 'Hostname',
    hostname: 'Hostname',
    setHostname: 'Establecer hostname',
    setHostnameTitle: 'Establecer hostname (set-hostname)',
    hostnameHint: 'Solo identidad del OS — el nombre del nodo en el clúster no se toca',
    notSet: 'no establecido',
    staticHostsTitle: 'Entradas host estáticas',
    addStaticHost: 'Añadir entrada',
    addStaticHostTitle: 'Añadir entrada host estática',
    delStaticHostTitle: 'Eliminar entrada host estática',
    hostIp: 'Dirección IP',
    hostNames: 'Nombres',
    hostNamesHint: 'separados por coma o espacio',
    colIp: 'IP',
    colNames: 'Nombres',
    noStaticHosts: 'Ninguna entrada host estática',
    delConfirm: 'Eliminación de {name} del documento deseado — el worker del nodo converge con un checkpoint de NetworkManager y rollback automático.',
    remove: 'Quitar',
    opError: 'La operación de red fue rechazada'
  }
}
